import useTranslation from '@/hooks/i18n';

export interface SectionTypeRef {
  documentId: string;
  value: string;
  label?: string | null;
}

export interface TopicLabelRef {
  documentId: string;
  value: string;
  label?: string | null;
}

export type KeyDateDateType = 'available_from' | 'month_action' | 'specific' | 'range' | 'tbc_relative' | 'deadline';

export interface KeyDate {
  documentId: string;
  title: string;
  description?: string | null;
  dateType: KeyDateDateType;
  startDate?: string | null;
  endDate?: string | null;
  relativeRule?: string | null;
  sectionType?: SectionTypeRef | null;
  topicLabel?: TopicLabelRef | null;
  month: string;
  requiresReview: boolean;
  isDeleted: boolean;
  originalText: string;
  source?: string | null;
  academicYear?: string | null;
  bookYourPlaceUrl?: string | null;
  learnMoreUrl?: string | null;
}

export interface PaginationInfo {
  page: number;
  pageCount: number;
  total: number;
  pageSize: number;
}

export const getKeyDateTags = (sectionType?: SectionTypeRef | null, topicLabel?: TopicLabelRef | null): string[] => {
  const tags: string[] = [];
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation();

  if (sectionType?.value && sectionType.value !== 'unknown') {
    tags.push(sectionType.label ?? t(sectionType.value));
  }

  if (topicLabel?.value) {
    tags.push(topicLabel.label ?? t(topicLabel.value));
  }

  return tags;
};
